/** Descarga de blobs devueltos por la API (XML / PDF de facturas). */

export function saveBlob(blob: Blob | null, filename: string): void {
    if (!blob) return;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

/** Nombre sugerido por el backend en Content-Disposition, con respaldo. */
export function filenameFromResponse(
    res: { headers: { get(name: string): string | null } },
    fallback: string
): string {
    const cd = res.headers.get('Content-Disposition') ?? '';
    const match = /filename="?([^"]+)"?/i.exec(cd);
    return match?.[1] ?? fallback;
}
